module.exports = __webpack_public_path__ + "static/media/info.304eca4f.svg";